module.exports = __webpack_public_path__ + "assets/img/bro1.d941df5a.png";